import axios from '@api'

export default {
  getMaterialGroup () {
    return axios.get(`api/management/materialgroup`)
  },
  deleteMaterialGroup (materialGroupId) {
    return axios.put(`api/management/materialgroup/delete/${materialGroupId}`)
  },
  saveMaterialGroup (json) {
    return axios.post(`api/management/materialgroup/save`, json)
  },
  getMaterialGroupList (json) {
    return axios.post(`api/management/materialgrouplist`, JSON.stringify(json))
  }
}
